import React from 'react';
import { Loader } from 'lucide-react';
import { formatSlotLabel } from '../../utils/appointmentSchedule';

/**
 * Rejilla de horarios de un día: estado de carga, error, vacío y botones.
 * Solo pinta: los datos vienen de useAvailableSlots.
 */
function SlotPicker({ slots, loading, error, selectedTime, onSelect, disabled = false }) {
  if (loading) {
    return (
      <div className="flex items-center gap-2 text-gray-600 text-sm py-2">
        <Loader className="h-4 w-4 animate-spin" />
        Cargando horarios...
      </div>
    );
  }

  if (error) return <p className="text-sm text-red-600 py-2">{error}</p>;

  if (slots.length === 0) {
    return <p className="text-sm text-gray-500 py-2">No hay horarios disponibles para esta fecha.</p>;
  }

  return (
    <div className="grid grid-cols-3 gap-2 max-h-48 overflow-y-auto pr-1">
      {slots.map((slot) => (
        <button
          key={slot.time}
          type="button"
          disabled={!slot.available || disabled}
          onClick={() => onSelect(slot.time)}
          className={`px-2 py-2 rounded-lg text-sm font-semibold border transition ${
            selectedTime === slot.time
              ? 'bg-blue-600 text-white border-blue-600'
              : slot.available
                ? 'bg-white text-gray-700 border-gray-300 hover:border-blue-500 hover:text-blue-600'
                : 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed line-through'
          }`}
        >
          {formatSlotLabel(slot.time)}
        </button>
      ))}
    </div>
  );
}

export default SlotPicker;
